import React from "react";

const Footer = () => {
  return (
    <footer className="bg-teal-600 text-white py-4 mt-12">
      <div className="max-w-6xl mx-auto text-center">
        © 2025 SumDocx. Tous droits réservés.
      </div>
    </footer>
  );
};

export default Footer;
